module.exports = __webpack_public_path__ + "img/cooperation11.116fdb7f.png";